import React from "react";
import "./Navara.scss";
import data from "./data.json";
import Card from "../../Component/Card/card";
import Navinaimages from "../../Media/KHI/Navara/Navina";
import Varaimages from "../../Media/KHI/Navara/Vara";

const imageMap = {
  Navinaimages,
  Varaimages,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="neweylon" className="produk1">
      <div className="cardhome-containercalamus">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
